<div class="table-wrapper-smaller">
  <div class="table-container">
    <table>
      <thead>
          <tr>
              <th>
                <input type="checkbox" id="all" [checked]="allChecked" (click)="selectAll($event.target.checked)">
                <label for="all"></label>
              </th>
              <th class="id sortable"  (click)="toOrderBy('x=> x.Id', 2)">
                {{'confeccionesDuplicar.table.id' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.Id', 2)"></i>
                </div>
              </th>
              <th class="string sortable" (click)="toOrderBy('x=> x.DenominacionUnica.Des', 3)">
                {{'confeccionesDuplicar.table.denominacion' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.DenominacionUnica.Des', 3)"></i>
                </div>
              </th>
              <th class="string">{{'confeccionesDuplicar.table.etiquetador' | translate}}</th>
              <th class="string sortable" (click)="toOrderBy('x=> x.Des', 5)">
                {{'confeccionesDuplicar.table.confeccion' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.Des', 5)"></i>
                </div>
              </th>
              <th class="string sortable" (click)="toOrderBy('x=> x.Alias', 6)">
                {{'confeccionesDuplicar.table.alias' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.Alias', 6)"></i>
                </div>
              </th>
              <th class="number sortable" (click)="toOrderBy('x=> x.Kilos', 7)">
                {{'confeccionesDuplicar.table.peso' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.Kilos', 7)"></i>
                </div>
              </th>
              <th class="number sortable" (click)="toOrderBy('x=> x.NumCajasTotales', 8)">
                {{'confeccionesDuplicar.table.nCajas' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.NumCajasTotales', 8)"></i>
                </div>
              </th>
              <th class="date sortable" (click)="toOrderBy('x=> x.fechaIns', 9)">
                {{'global.fecha.insercionShort' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.fechaIns', 9)"></i>
                </div>
              </th>
              <th class="date sortable" (click)="toOrderBy('x=> x.fechaUpd', 10)">
                {{'global.fecha.actualizacionShort' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.fechaUpd', 10)"></i>
                </div>
              </th>
          </tr>
      </thead>
      <tbody *ngFor="let confeccionPallet of confeccionesPallet; let i = index; trackBy: trackByConfeccionPalletId">
          <tr>
              <td>
                <input type="checkbox" [id]="'confeccionPallet_'+i" [checked]="selectedItems.includes(confeccionPallet.id)"
                  (click)="selectConfeccion(confeccionPallet, $event.target.checked)">
                <label [for]="'confeccionPallet_'+i"></label>
              </td>
              <td class="id">{{confeccionPallet.id}}</td>
              <td class="string">{{confeccionPallet.desDenominacionUnica}}</td>
              <td class="string">{{confeccionPallet.desEtiquetador}}</td>
              <td class="string">{{confeccionPallet.des}}</td>
              <td class="string">{{confeccionPallet.alias}}</td>
              <td class="number">{{confeccionPallet.kilos | number : '1.2-2': defaultLanguage}}</td>
              <td class="number">{{confeccionPallet.numCajasTotales}}</td>
              <td class="date">{{confeccionPallet.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}</td>
              <td class="date">{{confeccionPallet.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}</td>
          </tr>
      </tbody>
      <tfoot *ngIf="!confeccionesPallet || (confeccionesPallet && confeccionesPallet.length < 1)">
          <tr>
              <td colspan="10">
                  {{'global.noContent' | translate}}
              </td>
          </tr>
      </tfoot>
    </table>
  </div>
</div>
<app-toast *ngIf="(showError) && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
